import { CssBaseline, ThemeProvider } from "@mui/material";
import { createTheme, StyledEngineProvider } from "@mui/material/styles";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFnsV3";
import { createBrowserRouter, createRoutesFromElements, Outlet, Route, RouterProvider } from "react-router";

import { Provider } from "react-redux";
import React, { useEffect } from "react";
import { store } from "./store";
import { initTranslations } from "./store/reducers/translations";
import { loadPermissions } from "./store/reducers/permissions";
import { BlockUserInput } from "@jamezz/react-components";
import { AppRoutes } from "./Router";
import ErrorFestBoundary from "./ErrorFestBoundary";
import DialogProvider from "./licensing/utils/DialogProvider";
import { DialogProvider as DialogProviderV2 } from "./views/Upsell/modernTS/JUI/Dialogs";
import { nl } from "date-fns/locale/nl";
import { IntlProvider } from "react-intl";

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route
      element={
        <ErrorFestBoundary>
          <Outlet />
        </ErrorFestBoundary>
      }
    >
      {AppRoutes}
    </Route>
  )
);

export default function AppRoot() {
  useEffect(() => {
    initTranslations();
    loadPermissions();
  }, []);

  return (
    <IntlProvider locale={"nl"}>
      <Provider store={store}>
        <StyledEngineProvider injectFirst>
          <ThemeProvider
            theme={createTheme({
              palette: {
                mode: "light",
                primary: { main: "#f7844a", contrastText: "#fff" },
                error: { main: "#f44336" },
                background: { default: "#eeeeee" },
              },
              components: {
                MuiOutlinedInput: {
                  styleOverrides: {
                    input: { paddingTop: "8px", paddingBottom: "8px" },
                  },
                },

                MuiButton: {
                  styleOverrides: {
                    root: {
                      variants: [
                        {
                          props: { variant: "contained" },
                          style: {
                            // boxShadow:
                            //   "0 2px 2px 0 rgba(247, 132, 74, 0.14),0 3px 1px -2px rgba(247, 132, 74, 0.2),0 1px 5px 0 rgba(247, 132, 74, 0.12);",
                            // "&:hover": {
                            //   boxShadow:
                            //     "0 14px 26px -12px rgba(247, 132, 74, 0.42),0 4px 23px 0px rgba(0, 0, 0, 0.12),0 8px 10px -5px rgba(247, 132, 74, 0.2)",
                            // },
                          },
                        },
                      ],
                      borderRadius: 3,
                      fontSize: "12px",
                      padding: "10px 30px",
                    },
                  },
                },
              },
            })}
          >
            <CssBaseline />
            <LocalizationProvider adapterLocale={nl} dateAdapter={AdapterDateFns}>
              <DialogProvider>
                <DialogProviderV2>
                  <RouterProvider router={router} />
                  <BlockUserInput.View />
                </DialogProviderV2>
              </DialogProvider>
            </LocalizationProvider>
          </ThemeProvider>
        </StyledEngineProvider>
      </Provider>
    </IntlProvider>
  );
}
